/**
 * @generated SignedSource<<179859950e5f19e536fee83a97ac8eca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "accountid",
        "variableName": "accountId"
      }
    ],
    "concreteType": "AccountSpending",
    "kind": "LinkedField",
    "name": "getaccountspendingthismonth2",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "spentLastMonth",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "spentThisMonth",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "budget",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SpendingWidgetsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SpendingWidgetsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "62e3ed49519e08a109203dc02d48b065",
    "id": null,
    "metadata": {},
    "name": "SpendingWidgetsQuery",
    "operationKind": "query",
    "text": "query SpendingWidgetsQuery(\n  $accountId: UUID!\n) {\n  getaccountspendingthismonth2(accountid: $accountId) {\n    spentLastMonth\n    spentThisMonth\n    budget\n  }\n}\n"
  }
};
})();

node.hash = "4b677355fc589f85f55b6f8c0e2babb1";

module.exports = node;
